// getIsReachRateLimit.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getNetworkingData from '../selector/getNetworkingData.js';

/**
 * Select is reach rate limit by select path
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} selectPath - select path.
 * @param {number} nowUnixSecond - date now with second.
 * @return {boolean} The selected is reach rate limit.
 */
const getIsReachRateLimit = createCachedSelector(
  (state, selectPath) => getNetworkingData(state, selectPath, 'error'),
  (state, selectPath, nowUnixSecond) => nowUnixSecond,
  (networkingErrorData, nowUnixSecond) => {
    if (!networkingErrorData) return false;
    try {
      const { rateLimit } = JSON.parse(networkingErrorData.message);
      const { resetTime, remaining } = rateLimit;
      return resetTime > nowUnixSecond * 1000 && remaining === '0';
    } catch (error) {
      return false;
    }
  }
)((state, selectPath) => `${selectPath}`);

export default getIsReachRateLimit;
